import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { AddAreaApi } from "./areaAction";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import _ from "lodash";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddArea = (props) => {
  const [areaName, setAreaName] = useState("");
  const [areaDesc, setAreaDesc] = useState("");
  const [areaLocation, setAreaLocation] = useState("");

  function SaveArea() {
    props.AddAreaApi(
      {
        areaName: areaName,
        location: areaLocation,
        areaDesc: areaDesc,
      },
      showSuccessAlert,
      showErrorAlert
    );
    setAreaName("");
    setAreaDesc("");
    setAreaLocation("");
  }

  useEffect(() => {
    props.setHeading("Add Area");
  }, []);

  return (
    <>
      {props.isAddingArea ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Area Name *</b></Form.Label>
                <Form.Control
                  type="text"
                  value={areaName}
                  placeholder="Area Name"
                  onChange={(e) => { setAreaName(e.target.value); }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Area Location *</b> </Form.Label>
                <Form.Control
                  type="text"
                  value={areaLocation}
                  placeholder="Area Location"
                  onChange={(e) => { setAreaLocation(e.target.value); }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Description</b> </Form.Label>
                <Form.Control
                  type="text"
                  value={areaDesc}
                  placeholder="Description"
                  onChange={(e) => { setAreaDesc(e.target.value); }}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="sendDiv">
            {_.isEmpty(areaName) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveArea}> SAVE </Button>
            )}
          </div>

        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    AddAreaApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddAreaApi(data, showSuccessAlert, showErrorAlert)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isAddingArea: state.AreaReducer.isAddingArea,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddArea);